import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Form, List, Schema } from 'rsuite';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../Shared/Card/ReviewPdf';
import renewalService from '../../../../../services/Public/Renewal/renewal.service';
import peRenewalService, { getSections } from '../../../../../services/Internal/Renewal/PE/peRenewal.service';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Swal from 'sweetalert2';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function ReviewPage() {
    const [hasLoaded, setHasLoaded] = useState(true)
    const push = useNavigate();
    const appId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [violationIssuesHtml, setViolationIssuesHtml] = useState();
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Review"
        }
    );
    const sectionId = 8;
    useEffect(() => {
        peRenewalService.peGetSection(appId, sectionId).then((response) => {
            setIsComplete(response.data.staffReviewComplete);
            renewalService.getIndividualRenewal(appId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            });
        })
    }, [])


    const formSubmit = () => {
        peRenewalService.peMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
            if (data.data)
                Swal.fire("Success!", "You have saved successfully.", 'success')
        })
    }


    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                <br />

                <ReviewPdf id={appId} parentTypeId={3} />
                <br />
                <br />
                {hasLoaded ?
                    <>
                        {violationIssuesHtml}
                        <Container fluid>
                            <Row className="mt-3">
                                <Col style={{ display: "flex", alignItems: "center" }}>
                                    <label className="switch">
                                        <input id="completeSectionCheckbox" checked={isComplete} onChange={() => { if (isUserEditable) setIsComplete(!isComplete); }} type="checkbox" />
                                        <span className="slider round"></span>
                                    </label>&nbsp;
                                    <label htmlFor="completeSectionCheckbox">
                                        <b>Mark Section as Complete</b>
                                    </label>
                                    &nbsp;&nbsp;
                                    <Button name="backToSections" as={Link} to="/internal/perenewal/sections" variant="primary" className="me-2">Back to Sections</Button>
                                    {isUserEditable &&
                                        <Button name="save" onClick={formSubmit} variant="danger" className="me-2">Save</Button>
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage